import { CONNECTIONS_CONTACT_PAGE, CONNECTIONS_SYNC_PAGE, INDEX_PAGE, SIGN_IN_MODAL } from '@/constants';
import type { Context } from '@nuxt/types';
import { GOOGLE_OAUTH_KEY } from '~/components/partials/connections/constants';
import type { CurrentUser, IOauthProvider } from '~/types/';

const userHasGoogleContactPermission = (user: Partial<CurrentUser>) => {
  const { oauthProviders } = user;
  const googleProvider = oauthProviders?.find((provider: IOauthProvider) => provider.name === GOOGLE_OAUTH_KEY);

  return googleProvider && googleProvider.scopes?.some((scope: string) => scope.includes('contact'));
};

export default function authUser(ctx: Context) {
  const {
    app: { $utils },
    $auth,
    route,
  } = ctx;

  if (!$auth.loggedIn) {
    $utils.redirectWithQuery(INDEX_PAGE, { query: { dynamic_modal: SIGN_IN_MODAL } });
  }

  if (route.params.stepSlug === CONNECTIONS_SYNC_PAGE.params.stepSlug && userHasGoogleContactPermission($auth.user)) {
    $utils.redirectWithQuery(CONNECTIONS_CONTACT_PAGE);
  }
}
